module.exports = __webpack_public_path__ + "img/IN.a1b386d6.svg";